export default __webpack_public_path__ + "e954fb466dc4adb94ab55876e26084d9.svg";